<template>
  <div id="alertRoot" @click="hideAlertPage()">
    <div id="alertContainer">
      <div id="alertTitleDiv">
        <div id="alertTitleParent">提示</div>
        <div id="alertBackImgParent">
          <img id="alertBackImg" src="~assets/img//rebate-center/close_red.png" @click="hideAlertPage()"/>
        </div>
      </div>
      <div id="alertMessageTagParent">
        <label>{{$store.state.alertMessage}}</label>
      </div>
    </div>
  </div>
 </template>
 
 <script>
  export default {
    data () {
      return {}
    },
    components: {
    },
    methods:{
      // 隐藏提示页面
      hideAlertPage(){
        this.$store.commit('switchAlert', {"showOrHide": false, "alertMessage": "无"})
      }
    }
  }
 </script>
 
 <style>
#alertRoot{
    /* display: none; */
  width: 100%;
  height: 55vh;
  position: relative;
  background: rgba(51,51,51,0.5);
  z-index: 2233;
  display: flex;
  justify-content: center;
  align-items: center;
}
#alertContainer{
  width: 90%;
  height: 150px;
  position: absolute;
  background: #fff;
  z-index: 2255;
  border-radius: 10px 10px 10px 10px;
}

#alertTitleDiv{
  margin-top: 5px;
  width: 100%;
  height: 30px;
  display: inline-block;
  text-align: center;
}

#alertBackImgParent{
  display: inline-block;
  float: right;
  height: 30px;
  width: 30px;
  margin-right: 10px;
}
  
#alertBackImg{
  height: 100%;
  width: 100%;
}
  
#alertTitleParent{
  margin-left: 40px;/*这里的值是关闭按钮有30px，按钮靠右有10px，所以相加=40px*/
  height: 100%;
  justify-content: center; /*水平居中*/
  align-items: Center; /*垂直居中*/
  position: relative;
  display: inline-block;
  line-height: 30px;
  text-align: center;
  font-weight: bold;
  font-size: small;
}

#alertMessageTagParent{
  /* background-color: aqua; */
  width: 100%;
  height: 100px;
  display: -webkit-box;
  -webkit-box-orient: horizontal;
  -webkit-box-pack: center;
  -webkit-box-align: center;
  
  display: -moz-box;
  -moz-box-orient: horizontal;
  -moz-box-pack: center;
  -moz-box-align: center;
  
  display: -o-box;
  -o-box-orient: horizontal;
  -o-box-pack: center;
  -o-box-align: center;
  
  display: -ms-box;
  -ms-box-orient: horizontal;
  -ms-box-pack: center;
  -ms-box-align: center;
  
  display: box;
  box-orient: horizontal;
  box-pack: center;
  box-align: center;
  
}
#alertMessageTagParent label{
  position: absolute;
  padding: 10px;
  font-size: x-small;
}

</style>


// WEBPACK FOOTER //
// src/views/alert/Alert.vue